<template>
  <section class="side-bar">
    <div class="tab-container">
      <div
          class="tab"
          :class="{'tab-active': item.section===active}"
          v-for="item in list"
          @click="tabActive(item.section)"
      >
        <img
          :src="require(`../assets/img/common/${item['unselected_logo']}.png`)"
          v-show="item.section!==active"
        >
        <img
          :src="require(`../assets/img/common/${item['selected_logo']}.png`)"
          v-show="item.section===active"
        >
        <span>{{ item.section }}</span>
      </div>
    </div>
    <a
      class="download"
      :href="`https://www.tokenpocket.pro/`"
      target="_blank"
    >{{ $t('download') }}</a>
    <div class="thanks-container">
      <p class="thanks">{{ $t('thanks') }}</p>
    </div>
    <div class="github-container">
      <img class="github-icon" src="../assets/img/pc/github.png">
      <a class="github-desc" target="_blank" href="https://github.com/dappcom/dapps/tree/main">{{ $t('submitDApps') }}</a>
    </div>
  </section>
</template>

<script>
export default {
  name: "side-bar",
  props: {
    list: {
      type: Array
    },
    active: {
      type: String
    }
  },
  methods: {
    tabActive(section) {
      this.$parent.active = section
    }
  }
}
</script>

<style lang="less">
@media screen and (min-width: 1000px) {
  .side-bar {
    width: 225px;
    border-radius: 0 32px 32px 0;
    padding-bottom: 54px;
    margin-top: 50px;
    .tab-container {
      max-height: calc(87vh - 210px);
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .tab {
        height: 68px;

        img {
          width: 32px;
          margin-left: 44px;
        }

        span {
          font-size: 16px;
          margin-left: 14px;
        }
      }
    }

    .download {
      width: 176px;
      height: 44px;
      line-height: 44px;
      border-radius: 22px;
      margin: 36px auto 0;
      font-size: 16px;
    }
    .thanks-container {
      margin: 13px auto 0;
      width: 166px;
      height: 34px;
      .thanks {
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .side-bar {
    width: 150px;
    border-radius: 0 21px 21px 0;
    padding-bottom: 53px;
    margin-top: 33px;
    .tab-container {
      max-height: calc(87vh - 140px);
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .tab {
        height: 45px;

        img {
          width: 21px;
          margin-left: 29px;
        }

        span {
          font-size: 12px;
          margin-left: 9px;
        }
      }
    }

    .download {
      width: 117px;
      height: 29px;
      line-height: 29px;
      border-radius: 15px;
      margin: 24px auto 0;
      font-size: 11px;
    }
    .thanks-container {
      margin: 9px auto 0;
      width: 110px;
      height: 21px;
      .thanks {
        font-size: 12px;
        line-height: 17px;
        width: 133%;
        transform: scale(0.75);
        transform-origin: 0 0;
      }
    }
    .github-container {
      transform: scale(0.75);
      transform-origin: center center;
    }
  }
}
.side-bar {
  background: #2761e7;
  position: absolute;
  bottom: 0;

  .tab-container {
    overflow-y: auto;
  }

  .tab {
    display: flex;
    align-items: center;
    cursor: pointer;

    &.tab-active {
      background-color: #f5f9ff;

      span {
        color: #101010;
      }
    }

    span {
      color: white;
    }
  }

  .download {
    cursor: pointer;
    background-color: white;
    font-weight: bold;
    text-align: center;
    display: block;
  }
  .thanks-container {
    .thanks {
      text-align: center;
      font-weight: 400;
      color: white;
    }
  }

  .github-container {
    display: flex;
    justify-content: center;
    margin-top: 35px;

    .github-icon {
      height: 16px;
    }

    .github-desc {
      margin-left: 6px;
      color: white;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-decoration: underline;
      font-size: 12px;
    }
  }
}
</style>
